import { PATH_DASHBOARD } from 'snq/helpers/path';

export const PATH_CORE_NOT_FOUND = `${PATH_DASHBOARD}/not-found`;
